<template>
  <div class="p-8 bg-[#F8FAFC] min-h-screen">
    <header class="flex lg:flex-row justify-between items-start lg:items-center mb-8 gap-6">
      <div class="flex items-center gap-4">
        <div class="p-3 bg-white rounded-2xl shadow-sm border border-gray-100">
          <img src="https://www.datafuse.fr/assets/logo_datafuse_automation%20(4).svg" class="h-8" alt="Client Logo" />
        </div>
        <div>
          <h1 class="text-2xl font-black text-gray-900 uppercase tracking-tight">Console de Pilotage</h1>
          <p class="text-sm text-gray-500 font-medium italic">Dimotec Diagnostics — Agence Montpellier</p>
        </div>
      </div>
      
      <div class="flex items-center gap-3 bg-white px-4 py-2 rounded-2xl border border-gray-100 shadow-sm">
        <div class="text-right">
          <p class="text-[10px] font-black text-gray-400 uppercase leading-none">Statut du site</p>
          <p class="text-sm font-bold text-green-500">Ouvert au public</p>
        </div>
        <div class="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center text-green-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
        </div>
      </div>
    </header>

    <div class="grid xl:grid-cols-3 gap-8">
      
      <div class="xl:col-span-2 space-y-8">
        
        <div class="bg-white rounded-[2.5rem] shadow-xl shadow-gray-200/40 p-8 border border-gray-50">
          <div class="flex justify-between items-center mb-8">
            <h2 class="text-xl font-black text-gray-800 uppercase tracking-widest text-sm">Contrôle de File : <span class="text-dimotec-orange">Accueil Devis</span></h2>
            <div class="flex gap-2">
              <span class="px-3 py-1 bg-gray-100 rounded-lg text-xs font-bold text-gray-500">8 personnes en attente</span>
            </div>
          </div>

          <div class="flex flex-col items-center justify-center py-10 bg-gray-50 rounded-[2rem] border-2 border-dashed border-gray-200 mb-8">
            <p class="text-xs font-black text-gray-400 uppercase tracking-[0.3em] mb-2">Numéro Actuel</p>
            <div class="text-8xl font-black text-[#222222] tabular-nums">A-042</div>
            <p class="mt-4 text-sm font-bold text-dimotec-orange">Caisse n°1 — (En attente depuis 4min)</p>
          </div>

          <div class="grid grid-cols-4 gap-4">
            <button class="flex flex-col items-center justify-center gap-3 p-6 bg-white border border-gray-200 rounded-3xl hover:bg-gray-50 transition-all active:scale-95 group">
              <div class="w-12 h-12 bg-gray-100 rounded-2xl flex items-center justify-center text-gray-500 group-hover:text-blue-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.334 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z" /></svg>
              </div>
              <span class="text-xs font-black uppercase tracking-widest">Précédent</span>
            </button>

            <button class="md:col-span-2 flex flex-col items-center justify-center gap-3 p-6 bg-blue-500 text-white rounded-3xl shadow-lg shadow-blue-200 hover:brightness-110 transition-all active:scale-95">
              <div class="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center">
                <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="3" d="M13 5l7 7-7 7M5 5l7 7-7 7" /></svg>
              </div>
              <span class="text-sm font-black uppercase tracking-[0.2em]">Appeler Suivant</span>
            </button>

            <button class="flex flex-col items-center justify-center gap-3 p-6 bg-white border border-gray-200 rounded-3xl hover:bg-gray-50 transition-all active:scale-95 group">
              <div class="w-12 h-12 bg-gray-100 rounded-2xl flex items-center justify-center text-gray-500 group-hover:text-blue-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <span class="text-xs font-black uppercase tracking-widest">Sauter</span>
            </button>
          </div>

          <button class="w-full mt-6 py-4 border border-red-100 text-red-400 rounded-2xl text-xs font-bold uppercase tracking-widest hover:bg-red-50 transition">
            Réinitialiser la file (Reset à zéro)
          </button>
        </div>

        <div class="bg-white rounded-[2.5rem] p-8 border border-gray-50 shadow-sm">
          <div class="flex justify-between items-center mb-6">
            <h3 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400">Collaborateurs Agence</h3>
            <button class="text-xs font-bold text-dimotec-orange">+ Ajouter un agent</button>
          </div>
          <div class="space-y-4">
            <div v-for="user in ['Enzo Viana', 'Sophie Martin']" :key="user" class="flex items-center justify-between p-4 bg-gray-50 rounded-2xl">
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 bg-[#222222] rounded-lg text-white text-[10px] flex items-center justify-center font-bold">{{ user.charAt(0) }}</div>
                <span class="text-sm font-bold">{{ user }}</span>
              </div>
              <select class="bg-transparent text-xs font-bold text-gray-500 outline-none">
                <option>Admin Magasin</option>
                <option>Opérateur Caisse</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="space-y-8">
        
        <div class="bg-[#222222] rounded-[2.5rem] p-6 text-white shadow-2xl">
          <h3 class="text-xs font-black uppercase tracking-[0.2em] text-dimotec-orange mb-6 text-center">Aperçu Borne Android</h3>
          <div class="aspect-[3/4] bg-white rounded-3xl overflow-hidden p-6 flex flex-col items-center text-[#222222] shadow-inner border-[6px] border-gray-800">
             <img src="https://www.datafuse.fr/assets/logo_datafuse_automation%20(4).svg" class="h-6 mb-10 opacity-50" />
             <p class="text-[10px] font-black uppercase mb-2 text-gray-400">Bienvenue chez Dimotec</p>
             <h4 class="text-sm font-extrabold text-center mb-8">Veuillez sélectionner votre service</h4>
             
             <div class="w-full space-y-3">
               <div class="w-full p-4 border-2 border-dimotec-orange rounded-2xl text-xs font-black text-center text-dimotec-orange">DIAGNOSTIC VENTE</div>
               <div class="w-full p-4 bg-gray-100 rounded-2xl text-xs font-black text-center text-gray-400">DIAGNOSTIC LOCATION</div>
               <div class="w-full p-4 bg-gray-100 rounded-2xl text-xs font-black text-center text-gray-400">AUTRE DEMANDE</div>
             </div>
             <div class="mt-auto pt-4 border-t w-full text-center">
               <p class="text-[8px] font-bold text-gray-300 italic uppercase">Powered by Datafuse Automation</p>
             </div>
          </div>
          <p class="text-center text-[10px] text-gray-500 mt-4 font-medium italic">Simulation de l'APK en temps réel</p>
        </div>

        <div class="bg-white rounded-[2.5rem] p-8 border border-gray-50 shadow-sm">
          <h3 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-6">Écrans TV Actifs</h3>
          <div class="space-y-4">
            <div class="flex items-center gap-4 p-3 border border-gray-100 rounded-2xl">
              <div class="w-16 h-10 bg-gray-900 rounded-lg flex items-center justify-center">
                <span class="text-[8px] font-bold text-white">A-042</span>
              </div>
              <div class="flex-1">
                <p class="text-xs font-bold text-gray-800">Écran Vitrine</p>
                <p class="text-[10px] text-green-500 font-black uppercase">En ligne</p>
              </div>
              <button class="text-gray-300 hover:text-dimotec-orange">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>